import { isFunction } from 'lodash';
import { useContextStore } from '@/stores/context';
import { shallowRef, getCurrentInstance } from 'vue';

export function useUnsavedDataWarning() {
  const vm = getCurrentInstance().proxy;

  const isUnsavedDataModalOpen = shallowRef(false);

  const contextStore = useContextStore();

  function closeUnsavedDataModal() {
    isUnsavedDataModalOpen.value = false;
    vm.emitter.emit('unsaved-data-cancel');
  }

  function confirmUnsavedDataModal() {
    isUnsavedDataModalOpen.value = false;
    vm.emitter.emit('unsaved-data-confirm');
  }

  function openUnsavedDataModal() {
    isUnsavedDataModalOpen.value = true;
  }

  function beforeCloseModalWithUnsavedData(propName) {
    if (!vm.hasDataChanges) {
      vm[propName] = false;
      return false;
    }

    openUnsavedDataModal();
    vm.emitter.once('unsaved-data-cancel', () => {
      vm[propName] = true;
    });
    vm.emitter.once('unsaved-data-confirm', () => {
      if (isFunction(this.discard)) this.discard();
      vm[propName] = false;
    });
  }

  function beforeNavWithUnsavedData(navCallback) {
    if (!vm.hasDataChanges) {
      contextStore.setAllowTabChange(true);
      return navCallback();
    }

    contextStore.setAllowTabChange(false);
    openUnsavedDataModal();

    vm.emitter.once('unsaved-data-confirm', () => {
      contextStore.setAllowTabChange(true);
      return navCallback();
    });
  }

  function beforeRouteLeave(to, from, next) {
    if (!vm.hasDataChanges) {
      contextStore.setAllowTabChange(true);
      return next();
    }

    contextStore.setAllowTabChange(false);
    openUnsavedDataModal();
    vm.emitter.once('unsaved-data-cancel', () => {
      next(false);
    });
    vm.emitter.once('unsaved-data-confirm', () => {
      if (isFunction(this.discard)) this.discard();
      contextStore.setAllowTabChange(true);
      next();
    });
  }

  return {
    isUnsavedDataModalOpen,
    closeUnsavedDataModal,
    confirmUnsavedDataModal,
    openUnsavedDataModal,
    beforeCloseModalWithUnsavedData,
    beforeNavWithUnsavedData,
    beforeRouteLeave,
  };
}
